export default __webpack_public_path__ + "media/images/portfolio/gallery-02-480x290-53f9db0bde42c930a9f5b0f7017b88d6.jpg";